export const STREAM_ROUTER_ROOT: string = '/stream';
export const STREAM_ROUTER_LIVE: string = `${STREAM_ROUTER_ROOT}/live`;
export const STREAM_ROUTER_NEW: string = `${STREAM_ROUTER_ROOT}/new`;
export const STREAM_ROUTER_EDIT: string = `${STREAM_ROUTER_ROOT}/edit/:id`;
export const STREAM_ROUTER_VIEW: string = `${STREAM_ROUTER_ROOT}/view/:id`;



// WEBPACK FOOTER //
// ./src/components/Stream/LiveStream/constants.ts